import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsDoneStateAnimationEnabled = () => {
  const { value: isDoneStateAnimationEnabled } = useFeatureGate(
    'phx_done_state_animation',
  );
  return isDoneStateAnimationEnabled;
};
